import { PageScoringHandler } from "./levels/page";
import { ProductScoringHandler } from "./levels/product";
import { SectionScoringHandler } from "./levels/section";
import { SessionScoringHandler } from "./levels/session";
import { VisitorScoringHandler } from "./levels/visitor";

export const ScoringHandler = {
  setup() {
    ScoringHandler.Section.setup();
    ScoringHandler.Page.setup();
    ScoringHandler.Product.setup();
    ScoringHandler.Session.setup();
    ScoringHandler.Visitor.setup();
  },

  Section: SectionScoringHandler,
  Product: ProductScoringHandler,
  Page: PageScoringHandler,
  Session: SessionScoringHandler,
  Visitor: VisitorScoringHandler,
};

//
// scoringHandler -> levels ->
// section:
//  1. setup() -> IntersectionObserver + click/zoom observers
//  2. getScore()
// product:
//  1. setup() -> same
//  2. getScore()
// page:
//  1. setup() -> inferAndPersist()
// session:
//  1. setup() -> check for prev sessions and update + add-to-cart event listener with time
//                + begin checkout event listener with time + inferAndPersist()
//  visitor:
//  1. setup() ->inferAndPersist()
//
